import { createSlice } from "@reduxjs/toolkit";

const currencySlice = createSlice({
  name: "currency",
  initialState: {
    currentCurrency: {
      id: "united-states-dollar",
      currencyName: "United States Dollar",
      symbol: "USD",
      currencySymbol: "$",
      type: "fiat",
      rateUsd: "1.0000000000000000",
    },
  },
  reducers: {
    changeCurrency: (state, action) => {
      state.currentCurrency = action.payload;
    },
  },
});

export const { changeCurrency } = currencySlice.actions;

export const currentCurrency = (state) => state.currency.currentCurrency;

export default currencySlice.reducer;
